var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiveQuickNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Live_quickNav",
    transform: "translate(-4020 -2173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5544",
    "data-name": "Rectangle 5544",
    width: 24,
    height: 24,
    transform: "translate(4020 2173)",
    fill: "rgba(255,255,255,0.87)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11",
    transform: "translate(4020.612 2172.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M7.734,16.186a.6.6,0,0,1-.408-.162,5.563,5.563,0,0,1,0-8.069.6.6,0,0,1,.815.875,4.376,4.376,0,0,0,0,6.319.6.6,0,0,1-.408,1.037Zm-2.4,1.607a.6.6,0,0,0,0-.845,6.852,6.852,0,0,1,0-9.916.608.608,0,1,0-.845-.875,8.057,8.057,0,0,0,0,11.666.6.6,0,0,0,.851-.03Zm8.111-1.769a5.563,5.563,0,0,0,0-8.069.6.6,0,0,0-.821.875,4.358,4.358,0,0,1,0,6.319.6.6,0,0,0,.821.875Zm2.83,1.8a8.039,8.039,0,0,0,0-11.666.6.6,0,0,0-.815.875,6.852,6.852,0,0,1,0,9.916.6.6,0,1,0,.815.875Zm-4.688-5.833a1.2,1.2,0,1,0-1.2,1.2A1.2,1.2,0,0,0,11.589,11.989Z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28_-_Outline",
    "data-name": "Path 28 - Outline",
    d: "M4.9,18.135a.747.747,0,0,1-.514-.2,8.207,8.207,0,0,1,0-11.884A.758.758,0,0,1,5.44,7.139a6.7,6.7,0,0,0,0,9.7.754.754,0,0,1,.169.8h.076l-.232.252a.754.754,0,0,1-.524.241Zm.012-12a.456.456,0,0,0-.318.129,7.907,7.907,0,0,0,0,11.45.447.447,0,0,0,.323.121.453.453,0,0,0,.255-.09l.058-.058a.451.451,0,0,0,0-.634,7,7,0,0,1,0-10.13.458.458,0,0,0-.319-.788Zm10.957,12h0a.749.749,0,0,1-.51-1.3,6.7,6.7,0,0,0,0-9.7l-.006-.006a.75.75,0,0,1,1.019-1.094l.009.008a8.189,8.189,0,0,1,0,11.884A.748.748,0,0,1,15.87,18.134Zm-.3-11.208a7,7,0,0,1,0,10.13.448.448,0,1,0,.609.657,7.889,7.889,0,0,0,0-11.444.45.45,0,0,0-.61.657Zm-2.533,9.41a.749.749,0,0,1-.512-1.3,4.208,4.208,0,0,0,0-6.1A.75.75,0,0,1,13.55,7.845a5.713,5.713,0,0,1,0,8.287.748.748,0,0,1-.51.2Zm0-8.394a.446.446,0,0,0-.328.142.451.451,0,0,0,.02.636,4.508,4.508,0,0,1,0,6.537.449.449,0,0,0,.306.778v.15l0-.15a.448.448,0,0,0,.306-.121,5.413,5.413,0,0,0,0-7.851A.448.448,0,0,0,13.037,7.942Zm-5.3,8.394h0a.747.747,0,0,1-.51-.2,5.713,5.713,0,0,1,0-8.288l.009-.008A.75.75,0,0,1,8.251,8.932l-.006.006a4.226,4.226,0,0,0,0,6.1.749.749,0,0,1-.511,1.3ZM7.425,8.068a5.413,5.413,0,0,0,0,7.847.448.448,0,0,0,.61-.657,4.526,4.526,0,0,1,0-6.534.45.45,0,0,0-.61-.657Zm2.965,5.271a1.349,1.349,0,1,1,1.349-1.349A1.351,1.351,0,0,1,10.39,13.338Zm0-2.4a1.049,1.049,0,1,0,1.049,1.049A1.05,1.05,0,0,0,10.39,10.94Z",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveQuickNav);
export default __webpack_public_path__ + "static/media/icon_Live_quickNav.bc997d4d10793b69c999d4084cc486a2.svg";
export { ForwardRef as ReactComponent };